import { render, staticRenderFns } from "./MasterDataGoods.vue?vue&type=template&id=53bf63e2&scoped=true"
import script from "./MasterDataGoods.vue?vue&type=script&lang=js"
export * from "./MasterDataGoods.vue?vue&type=script&lang=js"
import style0 from "./MasterDataGoods.vue?vue&type=style&index=0&id=53bf63e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf63e2",
  null
  
)

export default component.exports